export default __webpack_public_path__ + "static/media/LVGMC-logo-white.471ab1ba.svg";